/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How the prize pool is calculated. Only FIXED is meaningful — the pool is a fixed Fuel amount, split by the payout table's per-place percentages.
 * @export
 */
export const TournamentPrizeCalculation = {
    FIXED: 'FIXED'
} as const;
export type TournamentPrizeCalculation = typeof TournamentPrizeCalculation[keyof typeof TournamentPrizeCalculation];


export function instanceOfTournamentPrizeCalculation(value: any): boolean {
    for (const key in TournamentPrizeCalculation) {
        if (Object.prototype.hasOwnProperty.call(TournamentPrizeCalculation, key)) {
            if (TournamentPrizeCalculation[key as keyof typeof TournamentPrizeCalculation] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TournamentPrizeCalculationFromJSON(json: any): TournamentPrizeCalculation {
    return TournamentPrizeCalculationFromJSONTyped(json, false);
}

export function TournamentPrizeCalculationFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentPrizeCalculation {
    return json as TournamentPrizeCalculation;
}

export function TournamentPrizeCalculationToJSON(value?: TournamentPrizeCalculation | null): any {
    return value as any;
}

export function TournamentPrizeCalculationToJSONTyped(value: any, ignoreDiscriminator: boolean): TournamentPrizeCalculation {
    return value as TournamentPrizeCalculation;
}

